<form [formGroup]="abogadoForm" class="row g-3">
    <div>
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="form-group">
            <label for="email" class="form-label text3-tipografia-govco"
              >{{ comunText['email'] }} </label
            ><span class="text-danger"> *</span>
            <input
              type="text"
              class="form-control"
              id="email"
              formControlName="email"
              placeholder="correo@mail.com"
              appUppercase
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('email')?.invalid &&
                  abogadoForm.get('email')?.touched,
                autocompleted:
                  abogadoForm.get('email')?.value &&
                  abogadoForm.get('email')?.pristine,
              }"
              autocomplete="off"/>
            <div
              *ngIf="
                abogadoForm.get('email')?.invalid &&
                abogadoForm.get('email')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('email')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['correo-required'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('email')?.errors?.['pattern']"
                class="invalid-feedback">
                {{ comunText['email-pattern'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('email')?.errors?.['maxlength']"
                class="invalid-feedback">
                {{ comunText['email-maxlength'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="form-group">
            <label for="primerNombre" class="form-label text3-tipografia-govco"
              >{{ comunText['primer-nombre'] }} </label
            ><span class="text-danger"> *</span>
            <input
              type="text"
              class="form-control"
              id="primerNombre"
              formControlName="primerNombre"
              maxlength="25"
              [placeholder]="comunText['primer-nombre']"
              appUppercase
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('primerNombre')?.invalid &&
                  abogadoForm.get('primerNombre')?.touched,
                autocompleted:
                  abogadoForm.get('primerNombre')?.value &&
                  abogadoForm.get('primerNombre')?.pristine,
              }"
              (focus)="onFocus('primerNombre')"
              autocomplete="off"/>
            <div
              *ngIf="
                abogadoForm.get('primerNombre')?.invalid &&
                abogadoForm.get('primerNombre')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('primerNombre')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['primer-nombre-required'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('primerNombre')?.errors?.['pattern']"
                class="invalid-feedback">
                {{ comunText['nombre-pattern'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('primerNombre')?.errors?.['minlength']"
                class="invalid-feedback">
                {{ comunText['nombre-minlength'] }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="segundoNombre"
              class="form-label text3-tipografia-govco"
              >{{ comunText['segundo-nombre'] }}</label
            >
            <input
              type="text"
              class="form-control"
              id="segundoNombre"
              formControlName="segundoNombre"
              [placeholder]="comunText['segundo-nombre']"
              maxlength="25"
              appUppercase
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('segundoNombre')?.invalid &&
                  abogadoForm.get('segundoNombre')?.touched,
                autocompleted:
                  abogadoForm.get('segundoNombre')?.value &&
                  abogadoForm.get('segundoNombre')?.pristine,
              }"
              (focus)="onFocus('segundoNombre')"
              autocomplete="off"/>
            <div
              *ngIf="
                abogadoForm.get('segundoNombre')?.invalid &&
                abogadoForm.get('segundoNombre')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('segundoNombre')?.errors?.['pattern']"
                class="invalid-feedback">
                {{ comunText['nombre-pattern'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('segundoNombre')?.errors?.['minlength']"
                class="invalid-feedback">
                {{ comunText['nombre-minlength'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="form-group">
            <label for="primerApellido" class="form-label text3-tipografia-govco"
              >{{ comunText['primer-apellido'] }} </label
            ><span class="text-danger"> *</span>
            <input
              type="text"
              class="form-control"
              id="primerApellido"
              formControlName="primerApellido"
              [placeholder]="comunText['primer-apellido']"
              maxlength="25"
              appUppercase
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('primerApellido')?.invalid &&
                  abogadoForm.get('primerApellido')?.touched,
                autocompleted:
                  abogadoForm.get('primerApellido')?.value &&
                  abogadoForm.get('primerApellido')?.pristine,
              }"
              autocomplete="off"/>
            <div
              *ngIf="
                abogadoForm.get('primerApellido')?.invalid &&
                abogadoForm.get('primerApellido')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('primerApellido')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['primer-apellido-required'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('primerApellido')?.errors?.['pattern']"
                class="invalid-feedback">
                {{ comunText['apellido-pattern'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('primerApellido')?.errors?.['minlength']"
                class="invalid-feedback">
                {{ comunText['apellido-minlength'] }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label
              for="segundoApellido"
              class="form-label text3-tipografia-govco"
              >{{ comunText['segundo-apellido'] }}</label
            >
            <input
              type="text"
              class="form-control"
              id="segundoApellido"
              formControlName="segundoApellido"
              [placeholder]="comunText['segundo-apellido']"
              maxlength="25"
              appUppercase
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('segundoApellido')?.invalid &&
                  abogadoForm.get('segundoApellido')?.touched,
                autocompleted:
                  abogadoForm.get('segundoApellido')?.value &&
                  abogadoForm.get('segundoApellido')?.pristine,
              }"
              autocomplete="off"/>
            <div
              *ngIf="
                abogadoForm.get('segundoApellido')?.invalid &&
                abogadoForm.get('segundoApellido')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('segundoApellido')?.errors?.['pattern']"
                class="invalid-feedback">
                {{ comunText['apellido-pattern'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('segundoApellido')?.errors?.['minlength']"
                class="invalid-feedback">
                {{ comunText['apellido-minlength'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="form-group">
            <label for="tipoDocumento" class="form-label text3-tipografia-govco"
              >{{ comunText['tipo-documento'] }} </label
            ><span class="text-danger"> *</span>
            <select
              formControlName="tipoDocumento"
              class="form-select"
              type="text"
              id="tipoDocumento"
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('tipoDocumento')?.invalid &&
                  abogadoForm.get('tipoDocumento')?.touched,
                autocompleted:
                  abogadoForm.get('tipoDocumento')?.value &&
                  abogadoForm.get('tipoDocumento')?.pristine,
              }">
              <option disabled selected value="">
                {{ personaText['seleccione-opcion'] }}
              </option>
              <option
                *ngFor="let item of documentTypeListApoderado"
                [value]="item.Id">
                {{ item.Descripcion }}
              </option>
            </select>
            <div
              *ngIf="
                abogadoForm.get('tipoDocumento')?.invalid &&
                abogadoForm.get('tipoDocumento')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('tipoDocumento')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['tipo-documento-required'] }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="identificacion" class="form-label text3-tipografia-govco"
              >{{ comunText['numero-documento'] }} </label
            ><span class="text-danger"> *</span>
            <input
              type="text"
              class="form-control"
              id="identificacion"
              formControlName="identificacion"
              [placeholder]="comunText['numero-documento']"
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('identificacion')?.invalid &&
                  abogadoForm.get('identificacion')?.touched,
                autocompleted: isAutocompleted('identificacion'),
              }"
              (focus)="onFocus('identificacion')"
              (change)="
                updateIdentificationValidators(
                  abogadoForm.get('tipoDocumento')?.value
                )
              "
              autocomplete="off"/>
            <div
              *ngIf="
                abogadoForm.get('identificacion')?.invalid &&
                abogadoForm.get('identificacion')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('identificacion')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['numero-documento-required'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('identificacion')?.errors?.['minlength']"
                class="invalid-feedback">
                {{ validationMessage }}
              </div>
              <div
                *ngIf="abogadoForm.get('identificacion')?.errors?.['maxlength']"
                class="invalid-feedback">
                {{ validationMessage }}
              </div>
              <div
                *ngIf="abogadoForm.get('identificacion')?.errors?.['pattern']"
                class="invalid-feedback">
                {{ validationMessagePattern }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <div class="form-group">
            <label for="pais" class="form-label text3-tipografia-govco"
              >{{ comunText['country'] }} {{showAditionalText ? aditionalText : ''}}</label
            ><span class="text-danger"> *</span>
            <select
              formControlName="pais"
              class="form-select"
              type="text"
              id="pais"
              (change)="onChangeCountry($event)"
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('pais')?.invalid &&
                  abogadoForm.get('pais')?.touched,
                autocompleted: isAutocompleted('pais'),
              }"
              (focus)="onFocus('pais')">
              <option disabled selected value="">
                {{ personaText['seleccione-opcion'] }}
              </option>
              <option *ngFor="let item of countries" [value]="item.Id">
                {{ item.Nombre }}
              </option>
            </select>
            <div
              *ngIf="
                abogadoForm.get('pais')?.invalid && abogadoForm.get('pais')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('pais')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['country-required'] }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="!hideDepartment">
          <div class="form-group">
            <label for="departmento" class="form-label text3-tipografia-govco"
              >{{ comunText['departament'] }} {{showAditionalText ? aditionalText : ''}}</label
            ><span class="text-danger"> *</span>
            <select
              formControlName="departmento"
              class="form-select"
              type="text"
              id="departmento"
              (change)="onChangeDepartment($event)"
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('departmento')?.invalid &&
                  abogadoForm.get('departmento')?.touched,
                autocompleted: isAutocompleted('departmento'),
              }"
              (focus)="onFocus('departmento')">
              <option disabled selected value="">
                {{ personaText['seleccione-opcion'] }}
              </option>
              <option *ngFor="let item of departments" [value]="item.Id">
                {{ item.Nombre }}
              </option>
            </select>
            <div
              *ngIf="
                abogadoForm.get('departmento')?.invalid &&
                abogadoForm.get('departmento')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('departmento')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['departament-required'] }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="!hideMunicipality">
          <div class="form-group">
            <label for="municipio" class="form-label text3-tipografia-govco"
              >{{ comunText['municipality'] }} {{showAditionalText ? aditionalText : ''}}</label
            ><span class="text-danger"> *</span>
            <select
              formControlName="municipio"
              class="form-select"
              type="text"
              id="municipio"
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('municipio')?.invalid &&
                  abogadoForm.get('municipio')?.touched,
                autocompleted: isAutocompleted('municipio'),
              }"
              (focus)="onFocus('municipio')">
              <option disabled selected value="">
                {{ personaText['seleccione-opcion'] }}
              </option>
              <option *ngFor="let item of municipalities" [value]="item.Id">
                {{ item.Nombre }}
              </option>
            </select>
            <div
              *ngIf="
                abogadoForm.get('municipio')?.invalid &&
                abogadoForm.get('municipio')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('municipio')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['municipality-required'] }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="hideDepartment">
          <div class="form-group">
            <label for="departmento" class="form-label text3-tipografia-govco"
            >{{comunText['departament']}} {{showAditionalText ? aditionalText : ''}}</label
            ><span class="text-danger"> *</span>
            <input
              type="text"
              class="form-control"
              id="otroDepartamento"
              formControlName="otroDepartamento"
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('otroDepartamento')?.invalid &&
                  abogadoForm.get('otroDepartamento')?.touched,
                'autocompleted':
                  isAutocompleted('otroDepartamento'),
              }"
              (focus)="onFocus('otroDepartamento')"
              autocomplete="off"
              appUppercase
            />
            <div
              *ngIf="
                abogadoForm.get('otroDepartamento')?.invalid &&
                abogadoForm.get('otroDepartamento')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('otroDepartamento')?.errors?.['required']"
                class="invalid-feedback">
                {{comunText['departament-required']}}
              </div>
              <div
                *ngIf="abogadoForm.get('otroDepartamento')?.errors?.['maxlength']"
                class="invalid-feedback">
                {{comunText['department-maxlength']}}
              </div>
              <div
                *ngIf="abogadoForm.get('otroDepartamento')?.errors?.['pattern']"
                class="invalid-feedback">
                {{comunText['department-pattern']}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="hideMunicipality">
          <div class="form-group">
            <label for="otroMunicipio" class="form-label text3-tipografia-govco"
            >{{comunText['municipality']}} {{showAditionalText ? aditionalText : ''}}</label
            ><span class="text-danger"> *</span>
            <input
              type="text"
              class="form-control"
              id="otroMunicipio"
              formControlName="otroMunicipio"
              [ngClass]="{
                'is-invalid':
                  abogadoForm.get('otroMunicipio')?.invalid &&
                  abogadoForm.get('otroMunicipio')?.touched,
                'autocompleted':
                  isAutocompleted('otroMunicipio'),
              }"
              (focus)="onFocus('otroMunicipio')"
              autocomplete="off"
              appUppercase
            />
            <div
              *ngIf="
                abogadoForm.get('otroMunicipio')?.invalid &&
                abogadoForm.get('otroMunicipio')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('otroMunicipio')?.errors?.['required']"
                class="invalid-feedback">
                {{comunText['municipality-required']}}
              </div>
              <div
                *ngIf="abogadoForm.get('otroMunicipio')?.errors?.['maxlength']"
                class="invalid-feedback">
                {{comunText['municipality-maxlength']}}
              </div>
              <div
                *ngIf="abogadoForm.get('otroMunicipio')?.errors?.['pattern']"
                class="invalid-feedback">
                {{comunText['municipality-pattern']}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="direccion" class="form-label text3-tipografia-govco"
              >{{ comunText['direccion-notificacion-judicial'] }} </label
            ><span class="text-danger"> *</span>
            <div class="d-flex align-items-center">
              <input
                type="text"
                class="form-control"
                id="direccion"
                formControlName="direccion"
                [placeholder]="
                  comunText['direccion-notificacion-judicial-placeholder']
                "
                appUppercase
                [ngClass]="{
                  'is-invalid':
                    abogadoForm.get('direccion')?.invalid &&
                    abogadoForm.get('direccion')?.touched,
                  autocompleted: isAutocompleted('direccion'),
                }"
                (focus)="onFocus('direccion')"
                autocomplete="off"
                maxlength="40"/>
            </div>
            <div
              *ngIf="
                abogadoForm.get('direccion')?.invalid &&
                abogadoForm.get('direccion')?.touched
              ">
              <div
                *ngIf="abogadoForm.get('direccion')?.errors?.['required']"
                class="invalid-feedback">
                {{ comunText['direccion-notificacion-judicial-required'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('direccion')?.errors?.['pattern']"
                class="invalid-feedback">
                  {{ comunText['direccion-notificacion-judicial-pattern'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('direccion')?.errors?.['minlength']"
                class="invalid-feedback">
                {{ comunText['direccion-notificacion-judicial-minlength'] }}
              </div>
              <div
                *ngIf="abogadoForm.get('direccion')?.errors?.['maxlength']"
                class="invalid-feedback">
                {{ comunText['direccion-notificacion-judicial-maxlength'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</form>